// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const VEHICLE_MONITORING_SURFACES = {
    device: 'vehicle_monitoring_device',
    event: 'vehicle_monitoring_device_event',
    legacyDevice: 'vehicle_monitoring_legacy_device',
    retentionMinima: 'vehicle_monitoring_retention_minima',
};
export const VEHICLE_MONITORING_BOUNDARY_TAG = 'vehicle_monitoring_conformity_boundary';
export const VEHICLE_MONITORING_DEVICES_COLLECTION = 'grc_vehicle_monitoring_devices';
export const VEHICLE_MONITORING_EVENTS_COLLECTION = 'grc_vehicle_monitoring_device_events';
export const VEHICLE_MONITORING_EVIDENCE_OWNER = 'vehicle_monitoring_evidence';
export const VEHICLE_MONITORING_LIFECYCLES = ['in_preparation', 'in_use', 'withdrawn'];
export const VEHICLE_MONITORING_EVENT_KINDS = [
    'retention_observation',
    'device_fault',
    'data_extraction',
    'authority_handover',
];
export const VEHICLE_MONITORING_TRANSITION_POPULATIONS = [
    'installed_before_anchor',
    'on_or_after_anchor',
    'not_determined',
];
//# sourceMappingURL=vehicle-monitoring.js.map